/* @flow */

import { makeListLink } from './utils';

export default makeListLink({ pathname: '/privacy', children: 'privacy' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/PrivacyLink.js